import type React from "react";
import { HeartIcon } from "../icons";

interface FavoriteHeartProps {
  id?: string;
  active: boolean;
  onClick: (e: React.MouseEvent) => void;
  ariaLabel?: string;
  className?: string;
  iconClassName?: string;
  targetName?: string;
  children?: React.ReactNode;
}

export const FavoriteHeart: React.FC<FavoriteHeartProps> = ({
  id,
  active,
  onClick,
  ariaLabel,
  className = "",
  iconClassName = "",
  targetName = "no-target",
  children,
}) => {
  const defaultAriaLabel = active
    ? `Eltávolítás a kedvencekből: ${targetName}`
    : `Hozzáadás a kedvencekhez: ${targetName}`;

  return (
    <button
      id={id}
      type="button"
      role="button"
      onClick={onClick}
      className={`transition-all duration-300 ${
        children ? "" : "hover:bg-[#d97ab8]/10 text-[#9f98b5] hover:text-[#d97ab8]"
      } ${className}`}
      aria-label={ariaLabel || defaultAriaLabel}
    >
      {children ? (
        children
      ) : (
        <>
          <HeartIcon
            filled={active}
            className={`transition-all duration-300 ${
              active
                ? "text-[#d97ab8] scale-110 drop-shadow-[0_0_6px_rgba(217,122,184,0.5)] fill-[#d97ab8]"
                : "text-current opacity-70 hover:opacity-100"
            } ${iconClassName}`}
          />
          <span className="sr-only">{ariaLabel || defaultAriaLabel}</span>
        </>
      )}
    </button>
  );
};

export default FavoriteHeart;
